<script>
export let msg;

</script>



<style>

.error-panel-block {
	padding-top: 2rem !important;
	padding-bottom: 2rem !important;
}

.error-panel-block p {
	color: var(--text-light);
	text-align: center;
	font-size: 1.125rem;
}

</style>


<div class="panel-block error-panel-block">

	<p>
		{#if msg}{msg}{:else}Error!{/if}
	</p>

</div>

